import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.disabled ? '#f5f5f5' : '#ECECEC'};
  color: ${props => props.disabled ? '#999' : 'inherit'};
  font-size: 12px;
  padding: 0 12px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  width: 160px;
  border-radius: 5px;
  i {
    margin-right: 4px;
  }
  &:hover {
    background: ${props => props.disabled ? '#f5f5f5' : '#d0d0d0'};
  }
`;

@observer
class MeaningsToggleButton extends React.Component {
  render() {
    return (
      <Wrapper
        data-tip
        data-for='admin-toggle-button'
      >
        <Button
          disabled={!this.props.wordHasMeanings}
          onClick={this.props.wordHasMeanings ? this.props.onToggle : undefined}
        >
          {this.props.isShowingMeaningsView ? 'Show All Translations' : 'Show Meanings'}
        </Button>
      </Wrapper>
    );
  }
}

export default MeaningsToggleButton;
